import ServiceRequestCreateWorkflow from '../containers/ServiceRequestCreateWorkflow'
import ServiceRequestList from '../components/ServiceRequestList'
import ServiceRequest from '../containers/ServiceRequest'
import ServiceRequestSelect from '../containers/ServiceRequestSelect'

import {
  Assignment,
  GIAssignment,
  ChangeBeneficiary,
  ChangeGIModalPremium,
  ChangePaymentMethod,
  ChangePaymentMode,
  ChangePersonalInformation,
  ChangePolicyBenefit,
  // ChangePremiumAmount,
  ChangeRider,

  Lapse,
  GILapse,
  PaidUp,
  PolicyLoan,
  PolicySettle,
  Reinstatement,
  Surrender,
  Suspension,
  PolicyHoliday,
  TransferOut,
  Withdrawal
} from '../components/ServiceRequestTypes'


export default {
  path: 'sr',
  name: 'Service Request',
  component: ServiceRequest,
  redirect: '/osm/sr/list',
  meta: { label: 'osm.serviceRequest.header' },
  children: [{
      path: 'select',
      name: 'Select Service Request',
      meta: { label: 'osm.serviceRequest.select.header' },
      component: ServiceRequestSelect,
      props: true
    }, {
      path: 'create',
      name: 'Create Service Request',
      meta: { label: 'osm.serviceRequest.workflow-1' },
      component: ServiceRequestCreateWorkflow,
      props: true,
      children: [{
          path: 'cas',
          name: 'serviceRequest-cas',
          meta: { label: 'osm.serviceRequest.type.CAS.header' },
          component: Assignment,
          props: true,
        }, {
          path: 'gas',
          name: 'serviceRequest-gas',
          meta: { label: 'osm.serviceRequest.type.GAS.header' },
          component: GIAssignment,
          props: true,
        }, {
          path: 'cbf',
          name: 'serviceRequest-cbf',
          meta: { label: 'osm.serviceRequest.type.CBF.header' },
          component: ChangeBeneficiary,
          props: true,
        }, {
          path: 'cga',
          name: 'serviceRequest-cga',
          meta: { label: 'osm.serviceRequest.type.CGA.header' },
          component: ChangeGIModalPremium,
          props: true
        }, {
          path: 'cpm',
          name: 'serviceRequest-cpm',
          meta: { label: 'osm.serviceRequest.type.CPM.header' },
          component: ChangePaymentMethod,
          props: true,
        }, {
          path: 'cpo',
          name: 'serviceRequest-cpo',
          meta: { label: 'osm.serviceRequest.type.CPO.header' },
          component: ChangePaymentMode,
          props: true,
        }, {
          path: 'cpi',
          name: 'serviceRequest-cpi',
          meta: { label: 'osm.serviceRequest.type.CPI.header' },
          component: ChangePersonalInformation,
          props: true,
        }, {
          path: 'cpb',
          name: 'serviceRequest-cpb',
          meta: { label: 'osm.serviceRequest.type.CPB.header' },
          component: ChangePolicyBenefit,
          props: true,
        }, {
          path: 'lap',
          name: 'serviceRequest-lap',
          meta: { label: 'osm.serviceRequest.type.LAP.header' },
          component: Lapse,
          props: true,
        }, {
          path: 'gap',
          name: 'serviceRequest-gap',
          meta: { label: 'osm.serviceRequest.type.GAP.header' },
          component: GILapse,
          props: true,
        },
        // {
        //   path: 'cpa',
        //   name: 'serviceRequest-cpa',
        //   component: ChangePremiumAmount,
        //   props: true,
        // },
        {
          path: 'cri',
          name: 'serviceRequest-cri',
          meta: { label: 'osm.serviceRequest.type.CRI.header' },
          component: ChangeRider,
          props: true,
        }, {
          path: 'pau',
          name: 'serviceRequest-pau',
          meta: { label: 'osm.serviceRequest.type.PAU.header' },
          component: PaidUp,
          props: true,
        }, {
          path: 'plo',
          name: 'serviceRequest-plo',
          meta: { label: 'osm.serviceRequest.type.PLO.header' },
          component: PolicyLoan,
          props: true,
        }, {
          path: 'pse',
          name: 'serviceRequest-pse',
          meta: { label: 'osm.serviceRequest.type.PSE.header' },
          component: PolicySettle,
          props: true,
        }, {
          path: 'rei',
          name: 'serviceRequest-rei',
          meta: { label: 'osm.serviceRequest.type.REI.header' },
          component: Reinstatement,
          props: true,
        }, {
          path: 'sur',
          name: 'serviceRequest-sur',
          meta: { label: 'osm.serviceRequest.type.SUR.header' },
          component: Surrender,
          props: true,
        }, {
          path: 'sus',
          name: 'serviceRequest-sus',
          meta: { label: 'osm.serviceRequest.type.SUS.header' },
          component: Suspension,
          props: true,
        }, {
          path: 'hol',
          name: 'serviceRequest-hol',
          meta: { label: 'osm.serviceRequest.type.HOL.header' },
          component: PolicyHoliday,
          props: true,
        }, {
          path: 'tro',
          name: 'serviceRequest-tro',
          meta: { label: 'osm.serviceRequest.type.TRO.header' },
          component: TransferOut,
          props: true,
        }, {
          path: 'wid',
          name: 'serviceRequest-wid',
          meta: { label: 'osm.serviceRequest.type.WID.header' },
          component: Withdrawal,
          props: true,
        }
      ]
    },
    {
      path: 'list',
      name: 'Service Request List',
      meta: { label: 'osm.serviceRequest.srList' },
      component: ServiceRequestList,
      props: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Osm/ServiceRequest/route/index.js